import PriceCard from "../../../components/PriceCard";
import OperationalLayout from "../../../components/OperationalLayout";
import ClosingRateCard from "../../../components/ClosingRateCard";
import { useStores } from "../../../context/storesContext";
import PriceAnomalyCard from "../../../components/PriceAnomalyCard";
import TopRecurrencesCard from "../../../components/TopRecurrencesCard";
import useSWR from "swr";
import { AuditPrice, Price, RecurrencesFlop } from "../../../types/operational";
import { fetcherWithStoreKey } from "../../../utils/fetcher";
import { useSearchParams } from "react-router-dom";
import {
  useOptionClosingRate,
  useOptionHyperPriceAnomaly,
} from "../../../utils/options";
import { useTranslation } from "react-i18next";
import { useKpiVisibility } from "../../../kpis/useKpiVisibility";
import { useRange } from "../../../context/rangeContext";

function Prix() {
  const { selectedStore } = useStores();
  const [searchParams] = useSearchParams();
  const { getKpiRange } = useRange();
  
  const optionClosingRate = useOptionClosingRate();
  const optionHyperPriceAnomaly = useOptionHyperPriceAnomaly();

  const closingRange =
    searchParams.get("closingRange") ?? (getKpiRange("ClosingRate") || optionClosingRate?.[0].value);
  const anomalyRange =
    searchParams.get("anomalyRange") ?? (getKpiRange("PriceAnomaly") || optionHyperPriceAnomaly?.[0].value);

  //PRICE AUDIT
  const { data: priceAuditData, error: priceAuditError } = useSWR<AuditPrice>(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/priceAudit?storeType=${selectedStore?.storeType?.toUpperCase()}`,
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  // TOP REcurrences
  const { data: recurrencesData, error: recurrencesError } = useSWR<
    RecurrencesFlop[]
  >(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/recurrences`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );
  // Price cloture
  const { data: closingData, error: closingError } = useSWR<Price[]>(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/price?range=${closingRange}&storeType=${selectedStore?.storeType?.toUpperCase()}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );

  // Price cloture
  const { data: anomalyData, error: anomalyError } = useSWR<Price[]>(
    () =>
      selectedStore?.storeKey
        ? [
            `/operational/price?range=${anomalyRange}&storeType=${selectedStore?.storeType?.toUpperCase()}`,
            
            selectedStore?.storeKey as string,
          ]
        : null,
    ([url, storeEan]) =>
      fetcherWithStoreKey(url,  storeEan as string)
  );

  const {t}= useTranslation();
  const {isKpiExists, isModuleExists} = useKpiVisibility();
  
  if (!isModuleExists("Operationnel")) {
    return null;
  }

  return (
    <OperationalLayout title={t('operationnel.prix')}>
      {isKpiExists("Price", "PriceAudit") && (
        <PriceCard
          title={t('operationnel.audit_prix')}
          isLoading={!priceAuditData}
          isUnavailable={!!priceAuditError || priceAuditData?.priceAuditRate ===null}
          rateData={priceAuditData as AuditPrice}
          openInformationModal={() => null}
        />
      )}
      {selectedStore?.storeType === "hypermarket" && isKpiExists("Price", "ClosingRate") &&(
        <ClosingRateCard
          title={t('operationnel.taux_cloture_anomalies')}
          isLoading={!closingData}
          isUnavailable={!!closingError || closingData?.[0]?.sector === null}
          data={closingData as Price[]}
          options={optionClosingRate}
          range={"closingRange"}
          openInformationModal={() => null}
        />
      )}
      {isKpiExists("Price", "PriceAnomaly") && (
        <PriceAnomalyCard
          title={t('operationnel.details_anomalie_prix')}
          listValue={anomalyData as Price[]}
          isLoading={!anomalyData}
          isUnavailable={!!anomalyError || anomalyData?.[0]?.sector === null}
          storeType={selectedStore?.storeType!}
          options={optionHyperPriceAnomaly}
          range={"anomalyRange"}
          openInformationModal={() => null}
        />
      )}
      {isKpiExists("Price", "TopRecurrences") && (
        <TopRecurrencesCard
          title={t('operationnel.top_reccurences_anomlaies_j')}
          listValue={recurrencesData as RecurrencesFlop[]}
          isLoading={!recurrencesData}
          isUnavailable={!!recurrencesError || recurrencesData?.[0]?.eanSAC === null}
          openInformationModal={() => null}
        />
      )}
    </OperationalLayout>
  );
}

export default Prix;
